import { Button, Card, CardContent, Typography } from "@mui/material";
import React, { useState } from "react";
import { DeleteDraftDialog } from "../../Shared/DeleteDraftDialog";
import { FormSectionHeader } from "../../Shared/FormSectionHeader";

export const DraftActions = (deleteCallback: () => void, submitCallback?: () => void) => {

    const [loading, setLoading] = useState<boolean>(false);
    const [showDeletePrompt, setShowDeletePrompt] = useState<boolean>(false);

    const onDelete = (confirm: boolean) => {

        if (confirm) {
            setShowDeletePrompt(false);
            setLoading(true);
            deleteCallback();

        } else
            setShowDeletePrompt(false);
    };

    return (
        <Card>
            <FormSectionHeader label="Submit Request" />
            <CardContent>
                <Typography variant="subtitle1">
                    Once you have entered the required details and added all the materials you would like to include in the dispatch request, you can submit it for approval.
                </Typography>
                <Typography variant="subtitle1">
                    If material is being loaned, an expected return condition is required for each material in the dispatch request.
                </Typography>
                <Typography variant="subtitle1">
                    Before submitting, you have the option to delete this draft; you can not delete a request once it has been submitted.
                </Typography>
                <Button variant="contained" onClick={submitCallback} disabled={submitCallback === undefined}>
                    Submit
                </Button>
                <Button
                    variant="outlined"
                    color="error"
                    onClick={() => setShowDeletePrompt(true)}
                    disabled={loading}>Delete
                </Button>
            </CardContent>
            <DeleteDraftDialog open={showDeletePrompt} handleClose={onDelete} />
        </Card>
    );
};
